// filters: { source, status, intermediary, buyer, sector, country } arrays (empty = all) and a lowercase query.
// row: the row's dataset; sectors/countries are space-separated because a producer can span facilities.
export function inviteRowMatches(row, filters, query) {
  const includes = (selected, value) => selected.length === 0 || selected.includes(value || "");
  const overlaps = (selected, list) =>
    selected.length === 0 || (list || "").split(" ").some((value) => selected.includes(value));

  return (
    includes(filters.source, row.inviteSource) &&
    includes(filters.status, row.inviteStatus) &&
    includes(filters.intermediary, row.inviteIntermediary) &&
    includes(filters.buyer, row.inviteBuyer) &&
    overlaps(filters.sector, row.inviteSectors) &&
    overlaps(filters.country, row.inviteCountries) &&
    (row.inviteSearch || "").includes(query)
  );
}
